import PropTypes from 'prop-types';
import dayjs from 'dayjs';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// components
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// ----------------------------------------------------------------------

RHFDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  shouldDisableDate: PropTypes.func,
};

RHFDatePicker.defaultProps = {
  format: 'MM/YYYY',
  minDate: dayjs(),
  shouldDisableDate: null,
};

export default function RHFDatePicker({ name, format, minDate, maxDate, shouldDisableDate, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const value = field.value ? dayjs(field.value) : null;
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              renderInput={(params) => <TextField {...params} fullWidth />}
              {...field}
              value={value}
              onChange={(newValue) => field.onChange(newValue)}
              error={!!error}
              helperText={error?.message}
              minDate={minDate ? dayjs(minDate) : null}
              maxDate={maxDate ? dayjs(maxDate) : null}
              format={format}
              shouldDisableDate={shouldDisableDate}
              {...other}
              slotProps={{
                textField: {
                  style: {
                    backgroundColor: '#FFFFFF',
                    borderRadius: 0,
                    width: '100%',
                    border: 0,
                  },
                },
              }}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
}
